import { Component } from '@angular/core';

@Component({
  selector: 'awards',
  templateUrl: './awards.component.html'
})

export class AwardsComponent {
  title = 'Awards';
}



// WEBPACK FOOTER //
// ./src/app/awards.component.ts